import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { formatDecision, type RunStatus, type Verdict } from '@/lib/model-lab'

const RUN_STATUS_STYLES: Readonly<Record<RunStatus, string>> = {
  queued: 'bg-slate-100 text-slate-700 border-slate-200',
  running: 'bg-blue-100 text-blue-800 border-blue-200',
  completed: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  failed: 'bg-red-100 text-red-800 border-red-200',
  cancelled: 'bg-amber-100 text-amber-800 border-amber-200',
}

export function RunStatusBadge({ status }: { readonly status: RunStatus }) {
  return (
    <Badge variant="outline" className={cn('capitalize', RUN_STATUS_STYLES[status])}>
      {status}
    </Badge>
  )
}

const VERDICT_STYLES: Readonly<Record<Verdict, string>> = {
  correct: 'bg-emerald-50 text-emerald-800 border-emerald-300',
  wrong: 'bg-red-50 text-red-800 border-red-300',
  unlabeled: 'bg-background text-foreground border-border',
  error: 'bg-slate-100 text-slate-500 border-slate-200 italic',
}

interface DecisionChipProps {
  readonly decision: string | null
  readonly verdict: Verdict
  readonly errorText?: string | null
}

/** A contestant's decision, coloured by whether it matches the label. */
export function DecisionChip({ decision, verdict, errorText }: DecisionChipProps) {
  const text = verdict === 'error' ? (errorText ?? 'error') : formatDecision(decision)
  return (
    <span
      className={cn('inline-flex items-center rounded border px-1.5 py-0.5 text-xs whitespace-nowrap', VERDICT_STYLES[verdict])}
      title={verdict === 'error' ? (errorText ?? undefined) : verdict}
    >
      {text}
    </span>
  )
}
